import { TIndexableBlock } from "../../../types/general-block-types";
import ContactCard, { TContactCardProps } from "../../elements/contact-card/contact-card";
import Heading from "../../elements/heading/heading";
import styles from "./person-gallery-block.module.less";

export type TPersonGalleryBlockProps = {
  eyebrow?: string;
  heading?: string;
  text?: string;
  contactCards?: Array<TContactCardProps>;
} & TIndexableBlock;

export const PersonGalleryBlock = ({ eyebrow, heading, text, contactCards }: TPersonGalleryBlockProps) => {
  return (
    <section className={styles.wrapper}>
      <div className={[styles.innerWrapper, "max-width padded-sides"].join(" ")}>
        {(heading || text) && (
          <div className={styles.textWrapper}>
            {eyebrow && <p className={[styles.eyebrow, "eyebrow"].join(" ")}>{eyebrow}</p>}
            {heading && (
              <Heading
                semanticType={"h2"}
                visualType={"h2"}
                className={[styles.heading, "heading-max-width"].join(" ")}
              >
                {heading}
              </Heading>
            )}
            {text && <p className={[styles.text, "body-base text-max-width"].join(" ")}>{text}</p>}
          </div>
        )}

        {contactCards && contactCards.length > 0 && (
          <ul className={`${styles.list}`}>
            {contactCards.map((card, index) => {
              return (
                <li key={index} className={styles.item}>
                  <ContactCard {...card} />
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </section>
  );
};

export default PersonGalleryBlock;
